import { useEffect, useRef } from 'react';

export default function AdBanner() {
  const containerRef = useRef<HTMLDivElement>(null);
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current || !containerRef.current) return;
    initialized.current = true;

    const container = containerRef.current;

    // 1. Load the jads.js library script (async)
    const jadsScript = document.createElement('script');
    jadsScript.type = 'text/javascript';
    jadsScript.async = true;
    jadsScript.src = 'https://poweredby.jads.co/js/jads.js';
    jadsScript.setAttribute('data-cfasync', 'false');
    container.appendChild(jadsScript);

    // 2. Create the ins element
    const insElement = document.createElement('ins');
    insElement.id = '1106254';
    insElement.setAttribute('data-width', '728');
    insElement.setAttribute('data-height', '90');
    container.appendChild(insElement);

    // 3. Create the init script (also async, runs independently)
    const initScript = document.createElement('script');
    initScript.type = 'text/javascript';
    initScript.async = true;
    initScript.setAttribute('data-cfasync', 'false');
    initScript.textContent = "(adsbyjuicy = window.adsbyjuicy || []).push({'adzone':1106254});";
    container.appendChild(initScript);
  }, []);

  return (
    <div className="flex items-center justify-center my-4 md:container mx-auto px-4">
      <div ref={containerRef} />
    </div>
  );
}
